var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.inline
    ? _c(
        "div",
        {
          staticClass: "date-time-inline",
          class: { noTime: _vm.hideTimePicker, error: _vm.hasError },
        },
        [
          _c("w-date-picker", {
            ref: "datePicker",
            attrs: {
              "has-error": _vm.hasError,
              "popover-visibility": "focus",
              placeholder: _vm.labelDate,
              locale: _vm.locale,
            },
            model: {
              value: _vm.date,
              callback: function ($$v) {
                _vm.date = $$v
              },
              expression: "date",
            },
          }),
          !_vm.hideTimePicker
            ? _c("w-input-time", {
                attrs: {
                  placeholder: _vm.labelTime,
                  disabled: _vm.disableTimePicker,
                  "has-error": _vm.hasError,
                },
                model: {
                  value: _vm.time,
                  callback: function ($$v) {
                    _vm.time = $$v
                  },
                  expression: "time",
                },
              })
            : _vm._e(),
        ],
        1
      )
    : _c(
        "w-col",
        { attrs: { xs: "12", md: _vm.computedMd, "no-margin": "" } },
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12", lg: _vm.colWidth } },
                [
                  _c("w-date-picker", {
                    ref: "datePicker",
                    attrs: {
                      "has-error": _vm.hasError,
                      "popover-visibility": "focus",
                      label: _vm.labelDate,
                      fancy: "",
                      locale: _vm.locale,
                    },
                    model: {
                      value: _vm.date,
                      callback: function ($$v) {
                        _vm.date = $$v
                      },
                      expression: "date",
                    },
                  }),
                ],
                1
              ),
              !_vm.hideTimePicker
                ? _c(
                    "w-col",
                    { attrs: { xs: "12", lg: "6" } },
                    [
                      _c("w-input-time", {
                        attrs: {
                          fancy: "",
                          label: _vm.labelTime,
                          disabled: _vm.disableTimePicker,
                          "has-error": _vm.hasError,
                        },
                        model: {
                          value: _vm.time,
                          callback: function ($$v) {
                            _vm.time = $$v
                          },
                          expression: "time",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }